import { helper } from '@ember/component/helper';

/**
 * Whether given params are explicitly true or 'true'
 * Note: returns false for other truthy values (e.g. 't', 123)
 * @param {*[]} params
 * @return {boolean}
 */
export default helper(function isTrueHelper(params) {
  return params.every(v => v === true || v === 'true');
});
